import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryInvoiceTemplateDetailsColumn,
    HistoryInvoiceTemplateDetailsView,
} from "./historyInvoiceTemplateDetailsView";

const VIEW_OPTIONS = {
    selection: true,
    density: ViewDensity.MD,
};

export const createDefaultHistoryInvoiceTemplateChangeView =
    (): HistoryInvoiceTemplateDetailsView => ({
        type: ViewType.HISTORY_UPDATED_TRANSACTION,
        columns: [
            { id: HistoryInvoiceTemplateDetailsColumn.TIME },
            { id: HistoryInvoiceTemplateDetailsColumn.TEMPLATE_NAME },
            { id: HistoryInvoiceTemplateDetailsColumn.PREVIOUS },
            { id: HistoryInvoiceTemplateDetailsColumn.MODIFIED },
        ],
        filters: {},
        options: VIEW_OPTIONS,
    });

export const createDefaultHistoryInvoiceTemplateContentView =
    (): HistoryInvoiceTemplateDetailsView => ({
        type: ViewType.HISTORY_UPDATED_TRANSACTION,
        columns: [
            { id: HistoryInvoiceTemplateDetailsColumn.TIME },
            { id: HistoryInvoiceTemplateDetailsColumn.TEMPLATE_NAME },
            { id: HistoryInvoiceTemplateDetailsColumn.CHANGE },
        ],
        filters: {},
        options: VIEW_OPTIONS,
    });
